export const pageContent = {
  slideX: {
    slideContent:
      "The text content for the given slide, usually a paragraph or two. In the intro slide, this content represents the DEK. If the text includes more than one paragraph, just write {newParagraph} in between to split it up. Do not separate the paragraphs with line breaks.",
    photoFileName:
      "The file name of the photo that goes with the content above. The name needs to match exactly and include the suffix at the end (for example: “sample-photo-1.jpg”). If the content is a video, it needs to be in MP4 format, and it's recommended that you host it externally and input the link here. If left blank, the content will show up on a blank screen. (OPTIONAL)",
    photoPosition:
      'For engineers to fill out. This specifies what part of the photo should be centered on mobile — equivalent to the CSS <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/object-position">object-position</a> property. (OPTIONAL)',
  },
  slide0: {
    slideContent: "Moments That Captivated NYC in 2024",
    photoFileName: "102424_liberty_parade_4_copy.jpg",
    photoPosition: "55%",
  },
  slide1: {
    slideContent:
      "This was a year of political upheaval. In 2024, federal and local investigations ensnared the mayor and several of his top aides and agency leaders. A polarizing presidential election saw historic gains for Republicans across the five boroughs. And Palestine-solidarity protests embroiled college campuses in the city. {newParagraph} But 2024 was also a year for celebration. The New York Liberty won its first WNBA championship and were feted with a historic parade up the Canyon of Heroes. And a once-in-a-generation solar eclipse darkened the skies across the city.  {newParagraph} Here are some of THE CITY’s most dramatic photos from the past 12 months. ",
  },
  slide2: {
    slideContent:
      "Protesters at Foley Square in Manhattan hold banners with the names of people who died on Rikers Island, ahead of a Board of Correction meeting, Jan. 10, 2024.<em>Credit: Ben Fractenberg/THE CITY</em>",
    photoFileName: "011024_rikers_protest_1-scaled.jpg",
    photoPosition: "50% 0%",
  },
  slide3: {
    slideContent:
      "A person walks through a snow-covered Crown Heights park as a Nor’easter hits the city, Feb. 13, 2024.<em>Credit: Alex Krales/THE CITY</em>",
    photoFileName: "021324_snow_6 copy.jpg",
    photoPosition: "",
  },
  slide4: {
    slideContent:
      `Artist Paula Brooks displays her work at the <a href="https://www.thecity.nyc/2024/03/07/creedmoor-psychiatric-living-museum/">Living Museum</a> in Queen’s Creedmoor Psychiatric Center, Feb. 22, 2024.<em>Credit: Haidee Chu/THE CITY</em>`,
    photoFileName: "022224_living_museum_22_copy.jpg",
    photoPosition: "25%",
  },
  slide5: {
    slideContent:
      `Federal agents load materials taken from Mayor Eric Adams’ <a href="https://www.thecity.nyc/2024/02/29/winnie-greco-fbi-raid/"> aide Winnie Greco’s Bronx home</a> into the back of a truck, Feb. 29, 2024.<em>Credit: Yoav Gonen/THE CITY</em>`,
    photoFileName: "022924_greco_raid_1 copy.jpg",
    photoPosition: "",
  },
  slide6: {
    slideContent:
      "A person watches the solar eclipse in front of the Essex Street Market on the Lower East Side, April 8, 2024.<em>Credit: Katie Honan/THE CITY</em>",
    photoFileName: "040824_solar_eclipse_2.jpg",
  },
  slide7: {
    slideContent:
      "NYPD officers arrest pro-Palestine Columbia University students occupying a lawn on campus, April 18, 2024.<em>Credit: Gwynne Hogan/THE CITY</em>",
    photoFileName: "041824_columbia_palestine_6-scaled.jpg",
    photoPosition: "45%",
  },
  slide8: {
    slideContent:
      "Former President Donald Trump supporters show solidarity outside his trial in Manhattan Criminal Court, April 22, 2024.<em>Credit: Ben Fractenberg/THE CITY</em>",
    photoFileName: "042224_trump_trial_1 copy.jpg",
    photoPosition: "",
  },
  slide9: {
    slideContent:
      "Wholesaler Carolyn Bailly works out of her Flower District studio on West 28th Street, May 8, 2024.<em>Credit: Ben Fractenberg/THE CITY</em>",
    photoFileName: "050824_flower_district_1.jpg",
    photoPosition: "55%",
  },
  slide10: {
    slideContent:
      `City blacksmith <a href="https://www.thecity.nyc/2024/06/19/basketball-hoops-blacksmiths-welding/">Giovanni Romano</a> works on a new hoop inside a Parks Department workspace in Flushing Meadows Corona Park, May 14, 2024. <em>Credit: Ben Fractenberg/THE CITY</em>`,
    photoFileName: "051424_parks_hoops_blacksmiths_1.jpg",
    photoPosition: "",
  },
  slide11: {
    slideContent:
      `Volunteers tag <a href="https://www.thecity.nyc/2024/05/29/horseshoe-crab-jamaica-bay-festival/">horseshoe crabs</a> near the Cross Bay Veterans Memorial Bridge in Broad Channel, May 21, 2024.<em>Credit: Ben Fractenberg/THE CITY</em>`,
    photoFileName: "052124_horseshoe_crabs_10 copy.jpg",
    photoPosition: "35%",
  },
  slide12: {
    slideContent:
      "Sally Ann Hall, competing as Miss Subway M train, prepares for her performance backstage at the Coney Island Museum, May 31, 2024.<em>Credit: Alex Krales/THE CITY</em>",
    photoFileName: "053124_MissSubway_02-scaled.jpg",
    photoPosition: "40%",
  },
  slide13: {
    slideContent:
      "Venezuelan migrant Darwin charged $10 a cut outside a Brooklyn shelter that houses many recently-arrived immigrants, June 7, 2024.<em>Credit: Alex KralesTHE CITY</em>",
    photoFileName: "060724_migrant_darwin_1-scaled.jpg",
    photoPosition: "70%",
  },
  slide14: {
    slideContent:
      `A <a href="https://www.thecity.nyc/2024/06/26/surf-camp-rockaway-beach-youth-lessons/">Laru Beya surfer</a> in the kids group warms up before getting in the water off the Rockaways, June 22, 2024.<em>Credit: Ben Fractenberg/THE CITY</em>`,
    photoFileName: "062224_surf_school_7 copy.jpg",
    photoPosition: "40%",
  },
  slide15: {
    slideContent:
      "Parks Department restoration workers help maintain sculptures atop the Grand Army Plaza arch, July 9, 2024.<em>Credit: Alex Krales/THE CITY</em>",
    photoFileName: "070924_grand_army_restoration_3 copy.jpg",
    photoPosition: "40%",
  },
  slide16: {
    slideContent:
      "Assemblymember Jenifer Rajkumar prepares for a Bronx press conference on the seizure of illegal cannabis products, July 31, 2024.<em>Credit: Ben Fractenberg/THE CITY</em>",
    photoFileName: "073124_cannabis_seizure_rajkumar_1 copy.jpg",
    photoPosition: "40%",
  },
  slide17: {
    slideContent:
      "A group of migrants camp out near a temporary shelter on Randalls Island, Aug. 5, 2024.<em>Credit: Gwynne Hogan/THE CITY</em>",
    photoFileName: "080624_randalls_island_migrants_1 copy.jpg",
    photoPosition: "10%",
  },
  slide18: {
    slideContent:
      `Ecuadorian migrant, Maria, and her 7-year-old daughter, Monica, rush food to a Midtown construction site ahead of <a href="https://www.thecity.nyc/2024/05/29/horseshoe-crab-jamaica-bay-festival/">the lunch rush</a>, Aug. 21, 2024.<em>Credit: Ben Fractenberg/THE CITY</em>`,
    photoFileName: "082124_migrant_vendors_2 copy.jpg",
    photoPosition: "40%",
  },
  slide19: {
    slideContent:
      "An MTA Flushing maintenance facility worker watches a press conference about the proposed capital budget, Sept. 18, 2024.<em>Credit: Ben Fractenberg/THE CITY</em>",
    photoFileName: "091824_mta_maintenance_worker_1 copy.jpg",
    photoPosition: "45%",
  },
  slide20: {
    slideContent:
      "Mayor Eric Adams leaves Manhattan federal court after pleading not guilty to corruption charges, Sept. 27, 2024.<em>Credit: Alex Krales/THE CITY</em>",
    photoFileName: "092724_adams_arraignment_1.jpg",
    photoPosition: "",
  },
  slide21: {
    slideContent:
      `Venezuelan painter Roger Miranda created <a href="https://www.thecity.nyc/2024/10/15/immigrant-artwork-brooklyn-exhibit-clinton-hill/">a makeshift studio</a> in the Hall Street migrant shelter, Oct. 3, 2024.<em>Credit: Ben Fractenberg/THE CITY</em>`,
    photoFileName: "100324_hall_shelter_miranda_1 copy.jpg",
    photoPosition: "70%",
  },
  slide22: {
    slideContent:
      "Liberty forward Breanna Stewart high-fives fans during the team’s championship parade up the Canyon of Heroes, Oct. 24, 2024.<em>Credit: Ben Fractenberg/THE CITY</em>",
    photoFileName: "102424_liberty_parade_7 copy.jpg",
    photoPosition: "",
  },
  slide23: {
    slideContent:
      "Hundreds of Trump supporters line a street near Madison Square Garden ahead of the former president’s campaign event, Oct. 27, 2024.<em>Credit: Gwynne Hogan/THE CITY</em>",
    photoFileName: "102724_trump_msg_2 copy.jpg",
    photoPosition: "90%",
  },
  slide24: {
    slideContent:
      "Gov. Kathy Hochuls holds a press conference at her Midtown office about how New York officials will respond to Trump’s presidential win, Nov. 6, 2024.<em>Credit: Ben Fractenberg/THE CITY</em>",
    photoFileName: "110624_hochul_election_presser_2 copy.jpg",
    photoPosition: "",
  },
  slide25: {
    slideContent:
      "Traffic heads up First Avenue toward a future congestion pricing toll reader, Nov. 14, 2024.<em>Credit: Alex Krales/THE CITY</em>",
    photoFileName: "111524_congestion_tolls_3 copy.jpg",
    photoPosition: "",
  },
  slide26: {
    slideContent:
      "Smacked owner Roland Conner was overseeing the opening of a lounge in the basement of his state-licensed Bleecker Street cannabis shop, Nov. 21, 2024.<em>Credit: Ben Fractenberg/THE CITY</em>",
    photoFileName: "112124_smacked_conner_1_copy.jpg",
    photoPosition: "80%",
  },
  slide27: {
    slideContent: `Prompted by Trump’s win, Mott Haven couple Ryan Addario, left, and
Nicholas Caycedo got hitched at the city’s marriage bureau, in Manhattan, Dec. 5, 2024.<em>Credit: Ben Fractenberg /THE CITY</em>`,
    photoFileName: "120524_marriage_bureau_1 copy.jpg",
    photoPosition: "50%",
  },
  slide28: {
    slideContent:
      "Immigrant-rights advocates protest outside City Hall against Mayor Eric Adams meeting with incoming Trump-chosen border czar Tom Homan, Dec. 12, 2024.<em>Credit: /THE CITY</em>",
    photoFileName: "121224_deportation_protest_1.jpg",
    photoPosition: "40%",
  }
};
